import { useMutation } from '@tanstack/react-query';
import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';

export const cloneOKRApi = ({ sourceKR, includeTree = true, includeObj = true, includeKr = true }) => {
  const url = endpoints.rabbitGoals.cloneOKR;
  return sendRequest({
    method: 'POST',
    url,
    queryParams: {
      sourceId: sourceKR?.uuid,
      includeTree,
      includeObj,
      includeKr,
    },
    body: {
      ...sourceKR,
      text: `Copy of ${sourceKR?.text}`,
    },
    credentials: 'include',
  });
};

export const useCloneOKRMutation = () =>
  useMutation({
    mutationFn: async ({ okrDetails, cloneBothChildObjectivesAndKRs, cloneOnlyChildObjectives }) =>
      cloneOKRApi({
        sourceKR: okrDetails,
        includeTree: cloneBothChildObjectivesAndKRs || cloneOnlyChildObjectives,
        includeObj: cloneBothChildObjectivesAndKRs || cloneOnlyChildObjectives,
        includeKr: cloneBothChildObjectivesAndKRs,
      }),
  });
